/* 创建者 魏强(2018.1.23) */
<template>
  <div class="category-wrapper">
    <div
      class="category-item"
      :class="categoryActiveIndex == index ? 'categoryActive' : ''"
      v-for="(item, index) in catTree"
      :key="index"
    >
      <el-image
        style="width: 24px; margin-right: 22px"
        fit="cover"
        :src="item.image"
      ></el-image>
      <el-breadcrumb
        separator="/"
        @mouseenter.native="mouseEnter(item, index)"
      >
        <el-breadcrumb-item
          class="category-item-content"
          v-for="(cat2, cat2index) in item.children"
          v-if="cat2index < 3"
          :key="cat2.catId"
        >
          <router-link
            :to="{
              path: '/goods-list',
              query: { catname: cat2.name, cat_id: cat2.catId },
            }"
            :key="cat2.catId"
            target="_blank"
          >
            {{ cat2.name }}
          </router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      v-show="isShow"
      class="category-sub"
      :style="{ left: rightW + 'px' }"
    >
    <el-scrollbar style="height: 100%;">
      <div
        class="sub-item"
        :class="hoverActiveIndex == index ? 'hoverActive' : ''"
        v-for="(item, index) in subList"
        :key="item.catId"
        @mouseenter="mouseEnterSub(item, index)"
        @click="subHandler(item)"
      >
        {{ item.name }}
      </div>
    </el-scrollbar>
    </div>
    <div
      v-show="lastShow"
      class="last-sub"
      :style="{ left: subLeft + 'px' }"
    >
    <el-scrollbar style="height: 100%;">
      <div
        class="last-sub-item"
        v-for="(item, index) in lastList"
        :key="index"
        @click="lastSubHandler(item)"
      >
        {{ item.name }}
      </div>
    </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Breadcrumb, BreadcrumbItem, Image, Scrollbar } from "element-ui";
// 根据路由设置分类菜单是否显示 高春超
export default {
  props: {
    catTree: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Image.name]: Image,
    [Scrollbar.name]: Scrollbar,
  },
  data() {
    return {
      isShow: false,
      lastShow: false,
      rightW: 0,
      subLeft: 0,
      subList: [],
      lastList: [],
      iconList: [
        //  require('../../assets/images/')
      ],
      hoverActiveIndex: -1,
      categoryActiveIndex: -1
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    mouseEnter(item, index) {
      this.categoryActiveIndex = index
      // 2581
      if (index == 0 || index == 3 || index == 6 || index == 9 || index == 12) {
        this.rightW = 322;
      } else if (index == 1 || index == 4 || index == 7 || index == 10) {
        this.rightW = 322 * 2 + 120;
      } else {
        this.rightW = 324 * 2 + 120;
      }
      if (item.children.length > 0) {
        this.subList = item.children;
        this.isShow = true;
      }

      this.lastShow = false;
    },
    mouseOut(id) {
      this.isShow = false;
      this.lastShow = false;
      this.hoverActiveIndex = -1;
      this.categoryActiveIndex = -1
    },
    subHandler(item) {
      let text = this.$router.resolve({
        path: "/goods-list",
        query: { catname: item.name, cat_id: item.catId },
      });
      window.open(text.href, "_blank");
    },
    mouseEnterSub(item, index) {
      console.log(index, 5555);
      this.hoverActiveIndex = index;
      if (item.children.length > 0) {
        this.lastShow = true;
        if(this.categoryActiveIndex > 0 && (this.categoryActiveIndex == 2 || this.categoryActiveIndex == 5 || this.categoryActiveIndex == 8 || this.categoryActiveIndex == 11)) {
          this.subLeft = this.rightW - 160
        } else {
          this.subLeft = this.rightW + 164;
        }

      }
      this.lastList = item.children;
      console.log(this.lastList, "---------");
    },
    lastSubHandler(item) {
      let text = this.$router.resolve({
        path: "/goods-list",
        query: { catname: item.name, cat_id: item.catId },
      });
      window.open(text.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.category-wrapper {
  width: 1226px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* 左对齐 */
  position: relative;
  padding-top: 34px;
  .category-sub {
    position: absolute;
    top: 0px;
    width: 164px;
    background: rgba(234, 146, 95, 0.95);
    opacity: 0.95;
    height: 357px;
    z-index: 666666;
    left: 0;
    padding: 14px 0;
    box-sizing: border-box;
    overflow: auto;
    .sub-item {
      padding: 0 20px;
      font-size: 16px;
      line-height: 40px;
      cursor: pointer;
      color: #ffffff;
    }

    .sub-item:hover {
      opacity: 0.5;
      background: #ffffff;
      color: #ec671a;
    }

    .hoverActive {
      opacity: 0.5;
      background: #ffffff;
      color: #ec671a;
    }
  }

  .last-sub {
    position: absolute;
    top: 0;
    width: 160px;
    height: 356px;
    background: rgba(245, 201, 175, 0.95);
    z-index: 666666;
    left: 0;
    box-sizing: border-box;
    font-size: 16px;
    padding: 14px 0;
    overflow: auto;
    .last-sub-item {
      color: #fff;
      padding: 8px 14px;
      cursor: pointer;
    }
    .last-sub-item:hover {
      color: #ea925f;
    }
  }

  .category-item {
    width: 328px;
    height: 36px;
    margin-bottom: 34px;
    margin-right: 120px;
    display: flex;
    align-items: center;
    position: relative;
    &:hover {
      color: #ea925f;
    }

    .category-item-content {
      display: flex;
      align-items: center;
    }
  }
  .category-item:nth-of-type(3n + 0) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// category-menu.vue?4c9ee5dc